export default __webpack_public_path__ + "static/media/bol.d1a8e90e.svg";